// extracted by mini-css-extract-plugin
export default {"nav":"index_nav_F8tGe","navBox":"index_navBox_xVcgF","itemBox":"index_itemBox_p-Tc7","item":"index_item_lP8fD","active":"index_active_mt8Ol","dot":"index_dot_NMZZC"};